export class YearItem {
    constructor(yearNumber: number) {
      this.yearNumber = yearNumber;
    }
    public yearNumber: number;
  }